import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN as string;

// Inizializza Mixpanel solo se il token è definito
if (MIXPANEL_TOKEN) {
  mixpanel.init(MIXPANEL_TOKEN);
}

type MixpanelEventProps = Record<string, any>;

const Mixpanel = {
  track: (eventName: string, props?: MixpanelEventProps) => {
    // Traccia solo se Mixpanel è stato inizializzato
    if (MIXPANEL_TOKEN) {
      mixpanel.track(eventName, props);
    } else {
      console.debug(`[Mixpanel] ${eventName}`, props);
    }
  },

  identify: (userId: string) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.identify(userId);
    } else {
      console.debug(`[Mixpanel] identify:`, userId);
    }
  },

  setUserProperties: (props: MixpanelEventProps) => {
    if (MIXPANEL_TOKEN) {
      mixpanel.people.set(props);
    } else {
      console.debug(`[Mixpanel] setUserProperties:`, props);
    }
  },
};

export default Mixpanel;
